import Vue from 'vue';

import App from './App.vue';
import router from './router';
import store from './store';

import ElementUI from 'element-ui';
import './theme/index.css';

import VueLazyload from 'vue-lazyload';
import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;

// Style
import 'normalize.css/normalize.css';
import './styles/common.scss';
import './icons';

Vue.use(ElementUI);
Vue.use(VueLazyload, {
    error: require('./assets/images/default.png'),
    loading: require('./assets/images/default.png')
});

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
